import { FC, useContext, useMemo } from 'react'

import { AppContext } from 'providers/context/App'
import {
  facialPreCheck,
  fullEditFacialPreCheck,
  hydrafacialPreCheck,
  HYDRAFACIAL_IDS,
  laserPreCheck,
  microPreCheck,
} from 'utils/constants/Helpers'
import { serviceIDs } from 'utils/constants/services'
import { HEALTH_CHECK } from '../../../utils/constants/Enums'

import './health-check.scss'

interface Props {
  healthCheck: HEALTH_CHECK
}

const HealthCheckContent: FC<Props> = ({ healthCheck }) => {
  const { appMasterData } = useContext(AppContext)
  const { isLaserFacial, isMicroNeedling, category } = appMasterData

  const categoryId = category?.categoryId

  const isHydrafacial = useMemo(
    () => HYDRAFACIAL_IDS.includes(categoryId),
    [categoryId]
  )

  const isFullEditFacial = useMemo(
    () => serviceIDs?.[6] === categoryId,
    [categoryId]
  )

  const isSpecialFacial = isMicroNeedling || isHydrafacial || isFullEditFacial

  const checkInList = useMemo(() => {
    if (isLaserFacial) return laserPreCheck
    if (isMicroNeedling) return microPreCheck
    if (isHydrafacial) return hydrafacialPreCheck
    if (isFullEditFacial) return fullEditFacialPreCheck
    return facialPreCheck
  }, [isLaserFacial, isMicroNeedling, isHydrafacial, isFullEditFacial])

  const showSitTightMessage = !isSpecialFacial

  return (
    <div className="health-check-content">
      <p className="head-label">PRE-FACIAL CHECK-IN</p>
      {healthCheck === HEALTH_CHECK.YES ? (
        <>
          <h3>{checkInList.chooseHeader} </h3>
          <p>{checkInList.chooseContent}</p>
          {checkInList.chooseContentBottom && (
            <p>{checkInList.chooseContentBottom}</p>
          )}
        </>
      ) : (
        <>
          <h3>
            Almost there!
            <br /> {checkInList.header}
          </h3>
          <ul className="facialCheckList">
            {checkInList.items.map((item) => (
              <li key={`checkList-${item}`} data-testid="list-item">
                {item}
              </li>
            ))}
          </ul>
          {checkInList.note && <p>{checkInList.note}</p>}
          <p>
            {showSitTightMessage && 'If so, sit tight! '}
            {checkInList.footer}
          </p>
        </>
      )}
    </div>
  )
}

export default HealthCheckContent
